var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCouponUsage2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 54.5,
    fill: "white",
    stroke: "#D8E0E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3334 68C48.1535 68 42.3334 62.1799 42.3334 55C42.3334 47.8201 48.1535 42 55.3334 42C62.5133 42 68.3334 47.8201 68.3334 55C68.3334 62.1799 62.5133 68 55.3334 68ZM55.3334 51.1H50.1334V53.7H61.8334L55.3334 47.2V51.1ZM48.8334 56.3L55.3334 62.8V58.9H60.5334V56.3H48.8334Z",
    fill: "#3C7AE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponUsage2);
export default __webpack_public_path__ + "static/media/coupon_usage_2.5a9bb8b5bc98cff7efe5546789dfbb08.svg";
export { ForwardRef as ReactComponent };